import React from "react"
import { Wrapper } from "./style"
import Bloque from "../../blockLayout"
const block1 = props => {
  return (
    <Wrapper>
      <div className="container">
        <Bloque subtitle={props.subtitle} data={props.data} />
      </div>
    </Wrapper>
  )
}

export default block1
